import React from "react";
import { cn } from "@/lib/utils";

export const StatusPill = ({ label, color, icon: Icon, className, hint, testId = "status-pill" }) => (
  <span
    data-testid={testId}
    title={hint}
    aria-label={label}
    className={cn(
      "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap",
      color,
      className
    )}
  >
    {Icon ? <Icon className="h-3 w-3" /> : <span className="h-1.5 w-1.5 rounded-full bg-current opacity-80" />}
    {label}
  </span>
);

export default StatusPill;
